/**
 * Componente Login
 * Gerencia autenticação e seleção de polo do usuário
 */

import React, { useEffect, useState } from "react";
import api from "../../services/api";

import Modal from 'react-modal';
import "./Login.css";
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Cookies from 'js-cookie';

Modal.setAppElement('#root');

function Login({ setIsLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPoloModal, setShowPoloModal] = useState(false);
  const [polos, setPolos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const polosPerPage = 4;
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add('login-page');

    return () => {
      document.body.classList.remove('login-page');
    };
  }, []);

  /**
   * Realiza autenticação do usuário
   */
  const handleLogin = async (event) => {
    event.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      // ✅ Passo 1: Pegar o CSRF cookie ANTES DE TUDO
      await api.getCsrfCookie();

      const xsrfToken = Cookies.get('XSRF-TOKEN');
      if (!xsrfToken) {
        setError("Erro de autenticação: token de segurança ausente no navegador.");
        setIsLoading(false);
        return;
      }

      // ✅ Passo 2: Fazer login com o XSRF token
      await api.post("/login", {
        email: username,
        password: password,
      }, {
        headers: {
          'X-XSRF-TOKEN': xsrfToken
        }
      });

      // ✅ Passo 3: Agora que está logado, buscar os polos
      const response = await api.get("/user/polos-by-user");

      if (response.data.polos && response.data.polos.length > 0) {
        if (response.data.polos.length === 1) {
          // Se só houver 1 polo, já seleciona automaticamente
          await handlePoloSelect(response.data.polos[0]);
        } else {
          setPolos(response.data.polos);
          setShowPoloModal(true);
        }
      } else {
        setError("Nenhum polo disponível para este usuário");
      }

    } catch (error) {
      console.error("Erro ao autenticar ou buscar polos:", error);
      setError(error.response?.data?.message || "Usuário ou senha inválidos");
    } finally {
      setIsLoading(false);
    }
  };



  /**
   * Seleciona polo e finaliza autenticação
   */
  const handlePoloSelect = async (polo) => {
    try {
      setIsLoading(true);
      await api.switchPolo(polo.id);
      const userResponse = await api.get('/user');
      setIsLoggedIn(userResponse.data, polo);
      setIsLoading(false);
      setShowPoloModal(false);
      // Redireciona após selecionar o polo, tanto no mobile quanto no desktop
      if (userResponse.data.type === 'professor') {
        navigate('/chamadas');
      } else if (userResponse.data.type === 'nutricionista') {
        navigate('/nutricionista');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error("Erro ao selecionar polo:", error);
      if (error.response?.status === 419) {
        setError("Erro de segurança: Cookie de sessão/token ausente. Tente limpar cache e cookies.");
      } else if (error.response?.status === 401) { // Erro 401 de Auth::attempt falhou no backend
        setError(error.response?.data?.message || "Usuário ou senha inválidos.");
      } else {
        setError("Erro ao selecionar polo. Tente novamente.");
      }
      // Limpa os cookies em caso de erro
      Object.keys(Cookies.get()).forEach(cookieName => {
        Cookies.remove(cookieName);
      });
      setIsLoading(false); // Pare o loading spinner
    }
  };

  const handleExit = () => {
    Cookies.remove('userName');
    Cookies.remove('userType');
    Cookies.remove('poloName');
    setShowPoloModal(false);
  };

  const indexOfLastPolo = currentPage * polosPerPage;
  const indexOfFirstPolo = indexOfLastPolo - polosPerPage;
  const currentPolos = polos.slice(indexOfFirstPolo, indexOfLastPolo);
  const totalPages = Math.ceil(polos.length / polosPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className="login-container">
        <form className="login-form" onSubmit={handleLogin}>
          <h2>Login</h2>
          {error && <div className="error-message">{error}</div>}
          <input
            type="text"
            placeholder="Usuário"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            disabled={isLoading}
          />
          <input
            type="password"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={isLoading}
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? <LoadingSpinner /> : "Entrar"}
          </button>
        </form>
      </div>

      {showPoloModal && (
        <Modal
          isOpen={true}
          onRequestClose={() => { }} // Impede fechamento
          className="polo-modal"
          overlayClassName="polo-modal-overlay"
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
        >
          <div className="polo-selector-container">
            <h2>Selecione um Polo</h2>
            <div className="polo-list">
              {currentPolos.map(polo => (
                <button
                  key={polo.id}
                  className="polo-button"
                  onClick={() => handlePoloSelect(polo)}
                >
                  {polo.name}
                </button>
              ))}
            </div>
            {polos.length > polosPerPage && (
              <div className="pagination">
                <button
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </button>
                {Array.from({ length: totalPages }, (_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => paginate(i + 1)}
                    className={currentPage === i + 1 ? 'active' : ''}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  &gt;
                </button>
              </div>
            )}
            <button className="polo-exit-button" onClick={handleExit}>
              Sair
            </button>
          </div>
        </Modal>
      )}
    </>
  );
}

export default Login;